import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import iconTelaLogin from "../imagem/iconTelaLogin.svg";
import Rating from "@mui/material/Rating";
import CoracaoFav from "../imagem/coracaoFav.png";
import coracaoPreenchido from "../imagem/coracaoPreenchido.png";
import InfoModalInfoLivro from "../Componets/InfoModalInfoLivro";
import iconXsair from "../imagem/iconXsair.png";
import ConfirmacaoAvaliacao from "./ConfirmaçãoAvaliacao";
import "./ModalInfoLivro.css";
import Textarea from "@mui/joy/Textarea";
import { favoritarLivro, notificarLivroDisponivel } from "../services/api";
import ErroNaOperacao from "./ErroNaOperacao";

function ModalInfoLivro({
  abrirModal,
  fecharModal,
  sinopse,
  nome,
  avaliacao,
  genero,
  livrosDisponiveis,
  data,
  quantidadeAvaliacoes,
  idLivro,
  autor,
  favorito,
}) {
  const [openModalConf, setOpenModalConf] = useState(false);
  const [confirmarAcervo, setConfirmarAcervo] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);
  const [status, setStatus] = useState(favorito);
  const [erroMensagem, setErroMensagem] = useState(false)

  React.useEffect(() => {
    setStatus(favorito);
  }, [favorito, abrirModal]);

  function openModal() {
    fecharModal();
    setTimeout(() => {
      setOpenModalConf(false);
    }, 4000);
  }

  function openModalErroNaOperacao() {
    fecharModal();
    notificarLivro(idLivro);
    setTimeout(() => {
      setOpenModalError(false);
    }, 4000);
  }

  async function notificarLivro(id) {
    try {
      await notificarLivroDisponivel(id);
      setErroMensagem("Tente novamente mais tarde")
      setOpenModalConf(true);
    } catch (error) {
      setErroMensagem(error.response.data)
      setOpenModalError(true);
    }
  }

  async function favoritar() {
    await favoritarLivro(idLivro);
    setStatus(!status);
  }

  return (
    <div>
      <ConfirmacaoAvaliacao
        openModalConf={openModalConf}
        fecharModal={() => setOpenModalConf(false)}
        setOpenModalConf={setOpenModalConf}
        nome={nome}
        text="Fique tranquilo! Assim que o livro estiver disponível, você
                receberá um aviso no seu Gmail."
        tam="20.625rem"
      />
      <ErroNaOperacao
        abrirModal={openModalError}
        fecharModal={() => setOpenModalError(false)}
        text={erroMensagem}
      />

      {abrirModal && (
        <div>
          <Modal
            open={abrirModal}
            handleClose={fecharModal}
            onClose={fecharModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "37.5rem",
                height: "auto",
                bgcolor: "var(--cor-branco)",
                boxShadow: 24,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                p: 4,
                borderRadius: "1.25rem",
              }}
            >
              <img
                src={iconXsair}
                onClick={() => fecharModal()}
                className="img_iconX"
              />

              <img src={iconTelaLogin} className="img_iconTelaLogin" />

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--cor-roxoEscuro)",
                    gap: 1,
                  }}
                >
                  <Rating
                    name="text-feedback"
                    value={avaliacao}
                    readOnly
                    precision={0.5}
                    sx={{
                      color: "var(--cor-roxoEscuro)",
                      "& .MuiRating-iconEmpty": {
                        color: "var(--cor-roxoEscuro)",
                      },
                      fontSize: "2.0rem",
                    }}
                  />
                  <Box sx={{ ml: 2, color: "var(--cor-roxoEscuro)" }}>
                    ({quantidadeAvaliacoes})
                  </Box>
                </Box>

                {livrosDisponiveis === 0 && (
                  <Button
                    onClick={() => {
                      openModal();
                      openModalErroNaOperacao();
                    }}
                    sx={{
                      bgcolor: "var(--cor-roxoPastel)",
                      color: "var(--cor-roxoEscuro)",
                      border: "1px solid var(--cor-roxoEscuro)",
                      fontWeight: "43.75rem",
                      borderRadius: "0.5rem",
                      textTransform: "none",
                    }}
                  >
                    Me avise quando disponível
                  </Button>
                )}

                {!status ? (
                  <img
                    id="boxCoracao"
                    src={CoracaoFav}
                    onClick={favoritar}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <img
                    id="boxCoracao"
                    style={{ cursor: "pointer" }}
                    src={coracaoPreenchido}
                    onClick={favoritar}
                  />
                )}
              </Box>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.125rem",
                }}
              >
                <Typography
                  variant="h6"
                  component="h2"
                  sx={{
                    fontSize: "1.7rem",
                    width: "100%",
                    color: "var(--cor-preto)",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {nome}
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontWeight: 470,
                    fontSize: "1.063rem",
                    lineHeight: "0.75rem",
                    width: "100%",
                    color: "var(--cor-preto)",
                  }}
                >
                  {autor}
                </Typography>
              </Box>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <InfoModalInfoLivro title="Gênero" text={genero[0]} />
                <InfoModalInfoLivro title="Data de publicação" text={data} />
                <InfoModalInfoLivro
                  title="Livros disponíveis"
                  text={livrosDisponiveis}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{ fontSize: "1.3rem", color: "var(--cor-pretoApoio)" }}
                >
                  Sinopse
                </Typography>

                <Textarea
                  minRows={4}
                  maxRows={4}
                  sx={{
                    backgroundColor: "white",
                    marginTop: "0.063rem",
                    width: "100%",
                  }}
                  value={sinopse}
                />
              </Box>
            </Box>
          </Modal>
        </div>
      )}
    </div>
  );
}

export default ModalInfoLivro;
